/**
 * @graphql agg
 */

import { graphql } from 'react-relay';

import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

const ATLASSIAN_EMAIL_DOMAINS = ['@atlassian.com', '@atlassian.com.invalid', '@usersinbuckets.com'];

export type SnippetsCurrentUserEmailsQuery$data = {
	readonly user:
		| {
				readonly emails:
					| ReadonlyArray<
							| {
									readonly value: string | null | undefined;
							  }
							| null
							| undefined
					  >
					| null
					| undefined;
		  }
		| null
		| undefined;
};

const SnippetsCurrentUserEmailsQuery = graphql`
	query useIsAtlassianStaff_SnippetsCurrentUserEmailsQuery {
		user: confluence_atlassianUser(current: true) {
			emails {
				value
			}
		}
	}
`;

const isAtlassianEmail = (value: string): boolean =>
	ATLASSIAN_EMAIL_DOMAINS.some((domain) => value.endsWith(domain));

/**
 * Returns whether the current user is Atlassian staff (internal).
 * Used to gate internal-only UI such as the feedback Slack link.
 */
export const useIsAtlassianStaff = (): boolean => {
	const { data } = useQueryInterop<SnippetsCurrentUserEmailsQuery$data>(
		SnippetsCurrentUserEmailsQuery,
	);

	const emails = data?.user?.emails ?? [];
	return emails.some((email) => isAtlassianEmail(email?.value ?? ''));
};
